import { renderIndividualProductTemplateBlocks } from '../../util/BlockUtil';
export const IndividualProductTemplate = ({
  data,
  type,
  lang,
  global,
  width,
  popular_downloads_posts,
  related_content,
  tags,
  contentType,
}) => {
  return (
    <div className={type.replace(/\s/g, '')}>
      {renderIndividualProductTemplateBlocks({
        data,
        width,
        lang,
        global,
        categories: data.categories,
        locations: data.locations,
        partners: data.partners,
        popular_downloads_posts,
        related_content,
        contentType,
        tags,
        topics: data.topics,
        contentTags: data.contentTags,
        initialArticles: data.initialArticles,
        initialArticlesHasMore: data.initialArticlesHasMore,
        initialProductFamily: data.initialProductFamily,
      })}
    </div>
  );
};
